import Components from "../../components";

const Notifications = ({ data }) => {
  /*
  const notifications = [
    {
      id: 1,
      title: "Yeni Ürün Eklendi",
      message: "Yeni bir ürün kataloğumuza eklendi.",
    },
    {
      id: 1,
      title: "Yeni Ürün Eklendi",
      message: "Yeni bir ürün kataloğumuza eklendi.",
    },
  ];
  */
  const notifications = [];

  const onNotificationClick = (notification) => {
    console.log("Notification clicked:", notification);
  };
  return (
    <div>
      <div>
        {notifications.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-12 text-gray-500">
            <svg width="64" height="64" fill="none" viewBox="0 0 64 64">
              <circle cx="32" cy="32" r="30" stroke="#e4e4e4" strokeWidth="4" />
              <path
                d="M44 44L54 54"
                stroke="#bdbdbd"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <circle cx="30" cy="30" r="12" stroke="#bdbdbd" strokeWidth="3" />
            </svg>
            <div className="mt-4 text-lg font-semibold text-gray-700">
              Herhangi bir bildirim yok
            </div>
            <div className="text-sm text-gray-400 mt-1">
              Şu anda size ait bir bildirim bulunamadı.
            </div>
          </div>
        ) : (
          notifications.map((notification) => (
            <Components.NotificationItem
              key={notification.id}
              title={notification.title}
              message={notification.message}
              onClick={() => {
                onNotificationClick(notification);
              }}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default Notifications;
